<div class="referral">
<h2 mat-dialog-title>{{ data.message }}</h2>

<mat-dialog-actions>
  <button mat-button type="button" class="btn btn-lg btn-primary continue-btn" (click)="onSuccessResponse()">Submit Referral</button>
</mat-dialog-actions>
</div>